import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSourceModule } from '../data-source/data-source.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loader/loader.component';
import { RouterModule } from '@angular/router';
import { CardComponent } from './components/card/card.component';
import { CardContentComponent } from './components/card/card-content/card-content.component';
import { CardHeaderComponent } from './components/card/card-header/card-header.component';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { UnitPipe } from './components/file-upload/unit.pipe';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DefaultPipe } from './pipes/default.pipe';
import { CardFooterComponent } from './components/card/card-footer/card-footer.component';
import { HttpClientModule } from '@angular/common/http';
import { LabelComponent } from './components/label/label.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IntlModule } from '@progress/kendo-angular-intl';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GridModule } from '@progress/kendo-angular-grid';
import { BooleanPipe } from './pipes/boolean.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { ErrorsComponent } from './components/errors/errors.component';
import { ConsentComponent } from './components/consent/consent.component';
import { NotificationBarComponent } from './components/notification-bar/notification-bar.component';
import { UpperCaseDirective } from './directives/upper-case.directive';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { TrimDirective } from './directives/trim.directive';
import { PinElementDirective } from './directives/pin-element.directive';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { ShowPasswordDirective } from './directives/show-password.directive';
import { FullHeightDirective } from './directives/full-height.directive';
import { FixedElementComponent } from './components/fixed-element/fixed-element.component';
import { FilterHighlighterDirective } from './directives/filter-highlighter.directive';


const kendo: Array<any> = [
    ButtonsModule,
    InputsModule,
    GridModule,
    TooltipModule,
    UploadModule,
    HttpClientModule,
    DateInputsModule,
    DropDownsModule,
    IntlModule,
    NotificationModule,
    DialogsModule,
    PopupModule,
    LayoutModule,
    SortableModule
];

const declarations: Array<any> = [
    LabelComponent,
    LoaderComponent,
    CardComponent,
    CardContentComponent,
    CardHeaderComponent,
    CardFooterComponent,
    FileUploadComponent,
    UnitPipe,
    HasPermissionDirective,
    DefaultPipe,
    BooleanPipe,
    KeysPipe,
    ErrorsComponent,
    ConsentComponent,
    NotificationBarComponent,
    UpperCaseDirective,
    ErrorPageComponent,
    TrimDirective,
    PinElementDirective,
    ShowPasswordDirective,
    FullHeightDirective,
    FixedElementComponent,
    FilterHighlighterDirective,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        DataSourceModule,
        FormsModule,
        ...kendo
    ],
    declarations: [
        ...declarations,
    ],
    exports: [
        ...kendo,
        ...declarations,
        DataSourceModule,
    ],
})
export class SharedModule {
}
